import { UNIT_USER } from '../actionTypes'

export function unitUser(data){
  return{
    type: UNIT_USER,
    payload: data
  }

}